module.exports = __webpack_public_path__ + "ebay.jpg";